export function setCamerasCount(count) {
  return {
    type: '@notificaton/SET_CAMERAS_COUNT',
    payload: { count }
  };
}

export function setConfigCount(count) {
  return {
    type: '@notificaton/SET_CONFIG_COUNT',
    payload: { count }
  };
}

export function setRead(read) {
  return {
    type: '@notificaton/SET_READ',
    payload: { read }
  };
}
